import computeFullAddress from 'api/src/lib/shared/computefullAddress';
import { z } from 'zod';

export const ADDRESS_ROLE_MAP = {
  BILLING: 'Billing',
  SHIPPING: 'Shipping',
  WAREHOUSE: 'Warehouse',
  PRIMARY_BUSINESS: 'Primary Business',
  SUBSIDIARY: 'Subsidiary',
  OTHER: 'Other',
};

export const addressZod = z
  .object({
    addressCountry: z.string().optional().nullable(),
    streetAddress1: z.string().optional().nullable(),
    streetAddress2: z.string().optional().nullable(),
    googlePlaceId: z.string().optional().nullable(),
    city: z.string().optional().nullable(),
    postalCode: z.string().optional().nullable(),
    state: z.string().optional().nullable(),
  })
  .refine((data) => computeFullAddress(data) !== '', 'Address is required');

export const placeZod = z.object({
  description: z.string().optional().nullable(),
  primaryContact: z.object({ id: z.number(), name: z.string() }).optional().nullable(),
  phone: z.string().optional().nullable(),
  addressRoles: z.array(z.string()).default([]),
});

export const editBusinessEntityZod = z.object({
  name: z.string().optional().nullable(),
  bluebookId: z.string().optional().nullable(),
  roles: z.array(z.string()).optional().nullable(),
  disabled: z.boolean().optional(),
  customerPortalEnabled: z.boolean().optional(),
  customFields: z.any().optional().nullable(),
  receivablesAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  payablesAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  incomeAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
  expenseAccount: z
    .object({
      id: z.number().optional().nullable(),
      accountName: z.string().optional().nullable(),
      accountNumber: z.string().optional().nullable(),
    })
    .optional()
    .nullable(),
});
